export class Device {
  articleNo: number;
  articleUrl: string;
  categoryId: number;
  description: string;
  distributor: string;
  id: number;
  imageUrl: string;
  manufacturer: string;
  name: string;
  purchasePrice: number;
  salePrice: number;
  visible: boolean;
  partnerId: number;
  parentDeviceId: number;
  hasChildrenDevices: boolean;

  constructor() {
    this.articleNo = null;
    this.articleUrl = '';
    this.categoryId = null;
    this.description = '';
    this.distributor = '';
    this.id = null;
    this.imageUrl = '';
    this.manufacturer = '';
    this.name = '';
    this.purchasePrice = 0;
    this.salePrice = 0;
    this.visible = true;
    this.partnerId = null;
    this.parentDeviceId = null;
    this.hasChildrenDevices = false;
  }
}



// WEBPACK FOOTER //
// ./src/models/device.ts